const usd0 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const usd2 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export const money = (v) => (v == null || isNaN(v) ? "—" : usd0.format(v));
export const money2 = (v) => (v == null || isNaN(v) ? "—" : usd2.format(v));
export const pct = (v, d = 2) => (v == null || isNaN(v) ? "—" : `${Number(v).toFixed(d)}%`);
// n/d as a percentage rounded once, half-up, to 2 decimals using whole cents (matches the server's pct2)
export const pctOf = (n, d) => {
  if (n == null || !d) return null;
  const a = Math.round(Number(n) * 100), b = Math.round(Number(d) * 100);
  if (!b) return null;
  const s = Math.sign(a) * Math.sign(b), A = Math.abs(a), B = Math.abs(b);
  return (s * Math.floor((2 * A * 10000 + B) / (2 * B))) / 100;
};
export const int = (v) => (v == null || isNaN(v) ? "—" : Math.round(v).toLocaleString());

export function fmtValue(v, f) {
  if (f === "money") return money(v);
  if (f === "money2") return money2(v);
  if (f === "money_signed") return v == null ? "—" : `${v >= 0 ? "+" : "−"}${money(Math.abs(v))}`;
  if (f === "pct") return pct(v);
  if (f === "int") return int(v);
  return v ?? "—";
}

export const dateLabel = (iso, opts = { weekday: "short", month: "short", day: "numeric" }) => {
  if (!iso) return "—";
  const d = iso.length <= 10 ? new Date(`${iso}T12:00:00`) : new Date(iso);
  return d.toLocaleDateString("en-US", opts);
};

const asDate = (v) => (v instanceof Date ? v : typeof v === "string" && /^\d{1,2}:\d{2}/.test(v) ? new Date(`2000-01-01T${v.slice(0, 5).padStart(5, "0")}:00`) : new Date(v));
export const time12 = (v) => {
  if (!v) return "";
  const d = asDate(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
};
export const dateTime = (v, opts = {}) => {
  if (!v) return "";
  const d = asDate(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true, ...opts });
};
export const timeRange = (a, b) => [time12(a), time12(b)].filter(Boolean).join(" – ");


export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return dateLabel(iso);
};

export function downloadCSV(filename, rows, columns) {
  const cols = columns || Object.keys(rows[0] || {});
  const esc = (v) => {
    const s = v == null ? "" : typeof v === "object" ? JSON.stringify(v) : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [cols.join(","), ...rows.map((r) => cols.map((c) => esc(r[c])).join(","))].join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  a.download = filename;
  a.click();
}

export function parseCSV(text) {
  const rows = [];
  let row = [], cur = "", q = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (q) {
      if (ch === '"' && text[i + 1] === '"') { cur += '"'; i++; }
      else if (ch === '"') q = false;
      else cur += ch;
    } else if (ch === '"') q = true;
    else if (ch === ",") { row.push(cur); cur = ""; }
    else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && text[i + 1] === "\n") i++;
      row.push(cur); rows.push(row); row = []; cur = "";
    } else cur += ch;
  }
  if (cur || row.length) { row.push(cur); rows.push(row); }
  const clean = rows.filter((r) => r.some((c) => c.trim()));
  const headers = (clean[0] || []).map((h) => h.trim());
  return { headers, rows: clean.slice(1).map((r) => Object.fromEntries(headers.map((h, i) => [h, r[i] ?? ""]))) };
}

export const titleCase = (s) => String(s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
